// Indian vehicle registration number formats:
// Standard: XX00XX0000 (state code + district + series + number)
// e.g. MH12AB1234, DL8CAB5678
const PLATE_REGEX = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{1,4}$/;

export function validatePlate(plate) {
  const cleaned = plate.replace(/[\s-]/g, "").toUpperCase();
  return PLATE_REGEX.test(cleaned) ? cleaned : null;
}

export function formatPlate(plate) {
  return plate.replace(/[\s-]/g, "").toUpperCase();
}

// Commercial vehicles: Truck, Bus use yellow plates
export function isCommercial(vehicleType) {
  return vehicleType === "Truck" || vehicleType === "Bus";
}
